//3. Отказы после КП (кол-во ЦО, если Стадия заказа равно Отменено и Сумма заказа не равно 0)
export const isValidCancelAKP = (order): boolean => {
    const stage = order["stage-code"]?.toUpperCase();
    return stage === 'ОТМЕНЕНО' && !!order["contract-sum"]
}